import { render, staticRenderFns } from "./EHAdetail.vue?vue&type=template&id=5d8a93b7&scoped=true"
import script from "./EHAdetail.vue?vue&type=script&lang=js"
export * from "./EHAdetail.vue?vue&type=script&lang=js"
import style0 from "./EHAdetail.vue?vue&type=style&index=0&id=5d8a93b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8a93b7",
  null
  
)

export default component.exports